import { faX } from "@fortawesome/free-solid-svg-icons/faX";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../components/AtiraIcon";
import { Button } from "../../../../components/Button";
import { Flex } from "../../../../components/Flex";
import { PermissionInvite } from "../../../../model/permissions/PermisisonInvite";
import { Spacing } from "../../../../theme/Spacing";
import { usePermissionsContext } from "../../permissions-context";

const StyledButton = styled(Button)`
  margin: 0;
  padding: ${Spacing.s};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.s};
  color: ${({ theme }) => theme.white};
`;

type PendingMemberCREATEDProps = {
  invite: PermissionInvite;
};

export const PendingMemberPENDING: React.FC<PendingMemberCREATEDProps> = ({
  invite,
}) => {
  const { t } = useTranslation();

  const { setCancelInviteModalVisible, setCurrentInvite } =
    usePermissionsContext();

  const onCancel = () => {
    setCurrentInvite(invite);
    setCancelInviteModalVisible(true);
  };

  return (
    <Flex alignItems="center" gap="l">
      <StyledButton backgroundColor="danger" onClick={onCancel}>
        <AtiraIcon icon={faX} />
        {t("common.cancel")}
      </StyledButton>
    </Flex>
  );
};
